import { atom } from "jotai";
import type { Stop } from "../types";

export const ticketAgentsEnabledAtom = atom<boolean>(false);
export const ticketAgentsRequestedNameAtom = atom<string | null>(null);


export const ticketAgentsRequestedLlAtom = atom<string | null>(null); // "lat,lng"
export const ticketAgentsPoisAtom = atom<Stop[]>([]);

function parseLl(ll: string | null): { lat: number; lng: number } | null {
  if (!ll) return null;
  const [a, b] = ll.split(",").map((x) => Number(x.trim()));
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  return { lat: a, lng: b };
}

export const requestedTicketAgentPoiAtom = atom<Stop | null>((get) => {
  const name = (get(ticketAgentsRequestedNameAtom) ?? "").trim();
  const ll = parseLl(get(ticketAgentsRequestedLlAtom));
  const pois = get(ticketAgentsPoisAtom);

  if (ll) {
    
    const tol = 0.001; 
    let best: Stop | null = null;
    let bestD = Infinity;

    for (const p of pois) {
      const dLat = p.lat - ll.lat;
      const dLng = p.lng - ll.lng;
      if (Math.abs(dLat) > tol || Math.abs(dLng) > tol) continue;
      const d = dLat * dLat + dLng * dLng;
      if (d < bestD) {
        bestD = d;
        best = p;
      }
    }
    if (best) return best;
  }

  if (!name) return null;
  return pois.find((p) => p.name.trim() === name) ?? null;
});
